
import {store} from '../redux/store';

export const getTranslations = (translations) => {
  const state = store.getState();
  const currentLanguage = state.language;
  return translations[currentLanguage] || translations['RU'];
};
